import { defineAsyncComponent } from 'vue'
export default {
  "back-button": defineAsyncComponent(() => import("/nuxt-app/layouts/back-button.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/nuxt-app/layouts/default.vue").then(m => m.default || m)),
  empty: defineAsyncComponent(() => import("/nuxt-app/layouts/empty.vue").then(m => m.default || m)),
  sidebar: defineAsyncComponent(() => import("/nuxt-app/layouts/sidebar.vue").then(m => m.default || m))
}